<div class="flex flex-row">
    <ng-template #virtualGridRowItems></ng-template>
</div>